import React, { memo } from 'react';
import { Alert, Box, Button, CircularProgress, Collapse, Grid, Skeleton, Snackbar } from '@mui/material';
import StarSharpIcon from '@mui/icons-material/StarSharp';
import PushPinIcon from '@mui/icons-material/PushPin';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import ModalRecuperaCessao from 'pages/CapitalFlow/Cessao/componentes/ModalRecuperaCessao/ModalRecuperaCessao';
import { DepartamentosEnum } from 'components/Shared/Enums/DepartamentosEnum';
import Main from '../Main/Main';
import useHomeHook from './useHomeHook';
import IconesMenu from '../Shared/Enums/IconesMenu';
import './styles.scss';
import { SUBMENUS } from '../Shared/Enums/SubMenusEnum';
import { encodeBase64UrlSafe } from '../Utils/utils';

const bancosImages = require.context('../../assets/img', false, /banco-\d+\.png$/);

const Home = ({ escopoAcesso, setEscopoAcesso }) => {
  const {
    refNomeRef,
    listaDeFavoritos,
    loadingFavoritos,
    permissaoTelaPagamentos,
    openAlert,
    setOpenAlert,
    handleClose,
    controleTamanho,
    valorSaldoOperar,
    valorSaldoLiberado,
    mostraCapitalFlow,
    mostraDashboardFinanceiro,
    loadingDashboardFinanceiro,
    navegarTelaCapitalFlow,
    isPendingSaldo,
    isPendingValorOperado,
    valorSaldoOperado,
    qtdPendencias,
    isPendingQtdPendencias,
    loadingValorLiberado,
    loadingBuscaEtapa,
    openModalRecuperaCessao,
    buscaEtapaCapitalFlow,
    nomeEtapaCapitalFlow,
    comecarNovajornada,
    handleCloseModalRecuperaCessao,
    empresasDashboardHome,
    dashboardEmpresasAbertas,
    dashboardEmpresasCarregando,
    toggleDashboardEmpresa,
    recarregarDashboardEmpresa,
    classeFundoHomeDashboard,
    setarParametrosFinanceiro
  } = useHomeHook({
    escopoAcesso,
    setEscopoAcesso
  });

  const getBancoImagem = idBanco => {
    if (!idBanco) return null;

    try {
      return bancosImages(`./banco-${idBanco}.png`);
    } catch (error) {
      return null;
    }
  };

  const BoxFavorito = ({ favorito, disabled = false, controleTamanho, permissao = true }) => (
    <Grid className="card-item-grid" item xs={12} md={controleTamanho}>
      <Link
        to={`/iframe/${encodeBase64UrlSafe(favorito.CODDEPARTAMENTO)}/${encodeBase64UrlSafe(favorito.CODSUBMENU)}`}
        className={`card-item w-100 text-decoration-unset ${favorito.ICONE !== 'pin' ? 'hover-card' : ''} ${favorito.CORFUNDO ?? ''}`}
        onClick={
          disabled
            ? e => e.preventDefault()
            : !permissao
              ? e => {
                  e.preventDefault();
                  setOpenAlert(true);
                }
              : null
        }
      >
        <Grid className="controle-tamanho" item xs={3} sm={3} md={3} lg={2} xl={2}>
          <Box className="background-image">
            {favorito.ICONE === 'pin' && (
              <Box className="add-icon">
                <PushPinIcon />
              </Box>
            )}

            {favorito.ICONE !== 'pin' && (
              <Box className="add-icon">
                <IconesMenu name={favorito.ICONE} />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid item xs={8} sm={8} md={8} lg={9} xl={9}>
          <Box className="texto-com-reticencias">
            <span className="cor-texto-item">{favorito.SUBMENU}</span>
          </Box>
          <Box className="texto-com-reticencias">
            <strong className="cor-texto-item">{favorito.NOMEDEPARTAMENTO}</strong>
          </Box>
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
          <Box className="icone-seta-direita">
            <ArrowForwardIosIcon />
          </Box>
        </Grid>
      </Link>
    </Grid>
  );

  return (
    <Main
      title="Dashboard"
      className={`tela-dashboard ajuste-home ${classeFundoHomeDashboard}`}
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      <Box className="dashboard">
        <Grid container className="container-home">
          <Grid item xs={12} md={8} lg={10} xl={10}>
            <Box className="home-topo">
              <Box className="titulo-home">
                <Box id="texto-gerado-nome" className="texto-gerado-nome" ref={refNomeRef} />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={12} lg={12} xl={12}>
            {mostraCapitalFlow && (
              <Grid container className="container-boxes banner-capital-flow">
                <Grid item xs={12} md={4} lg={4} xl={4} className="grid-item-home-right">
                  <Box className="texto-indicacao">Para você</Box>
                  <Box className="box-item" onClick={() => buscaEtapaCapitalFlow()}>
                    <Grid container className="grid-container">
                      <Grid item className="grid-centralizada" xs={2} sm={3} md={3} lg={2} xl={2}>
                        <Box className="icone-item-esquerda">
                          <TaskAltIcon />
                        </Box>
                      </Grid>
                      <Grid item xs={7} sm={6} md={6} lg={8} xl={8}>
                        <Box>
                          <span className="texto-item">Libere para operar até</span>
                        </Box>
                        <Box>
                          {loadingValorLiberado && <Skeleton variant="text" width="50%" height={35} />}
                          {!loadingValorLiberado && (
                            <b className="valor-item">R$ {valorSaldoLiberado}</b>
                          )}
                        </Box>
                        <Box>
                          <span className="texto-item">Simule com o Capital Flow</span>
                        </Box>
                      </Grid>
                      <Grid item xs={3} sm={3} md={3} lg={2} xl={2}>
                        <Box className="icone-item-direita">
                          {!loadingBuscaEtapa && <ArrowForwardIcon />}
                          {loadingBuscaEtapa && <CircularProgress />}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>

          {mostraDashboardFinanceiro && (
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <Box className="home-dashboard-empresas">
                {loadingDashboardFinanceiro && empresasDashboardHome.length === 0 && (
                  <Box className="dashboard-empresa-item">
                    <Box className="texto-indicacao">Gestão Financeira</Box>
                    <Box className="dashboard-empresa-resumo aberto dashboard-empresa-resumo-loading">
                      <Box className="empresa-resumo-icone">
                        <AccountBalanceIcon />
                      </Box>
                      <Box className="empresa-resumo-texto">
                        <Skeleton variant="text" width="60%" height={28} />
                      </Box>
                      <KeyboardArrowDownIcon className="empresa-resumo-seta" />
                    </Box>

                    <Collapse in timeout="auto">
                      <Grid container spacing={2} className="dashboard-bancos-collapse">
                        {Array.from({ length: 2 }).map((_, index) => (
                          <Grid key={index} item xs={12} sm={6} md={4} className="itens-cards">
                            <Box className="dashboard-banco-card dashboard-banco-card-loading">
                              <Box className="dashboard-banco-card-topo">
                                <Box className="dashboard-banco-identificacao">
                                  <Skeleton variant="circular" width={40} height={40} />
                                  <Box className="dashboard-banco-loading-textos">
                                    <Skeleton variant="text" width={120} height={24} />
                                    <Skeleton variant="text" width={100} height={20} />
                                  </Box>
                                </Box>
                              </Box>

                              <Box className="dashboard-banco-card-base">
                                <Skeleton variant="rounded" width={40} height={40} />
                                <Box className="dashboard-banco-loading-textos">
                                  <Skeleton variant="text" width={90} height={20} />
                                  <Skeleton variant="text" width={130} height={28} />
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Collapse>
                  </Box>
                )}

                {empresasDashboardHome.length > 0 && (
                  <Box className="dashboard-empresa-item">
                    <Box className="texto-indicacao">Gestão Financeira</Box>
                  </Box>
                )}

                {empresasDashboardHome.map(empresa => (
                  <Box key={empresa.id} className="dashboard-empresa-item">
                    <Box
                      className={`dashboard-empresa-resumo ${dashboardEmpresasAbertas[empresa.id] ? 'aberto' : ''}`}
                      onClick={() => toggleDashboardEmpresa(empresa.id)}
                    >
                      <Box className="empresa-resumo-icone">
                        <AccountBalanceIcon />
                      </Box>
                      <Box className="empresa-resumo-texto">{empresa.label}</Box>

                      <Box className="dashboard-empresa-resumo-acoes">
                        <Button
                          className="dashboard-empresa-btn-recarregar"
                          variant="outlined"
                          size="small"
                          aria-label="Recarregar"
                          onClick={evento => {
                            evento.stopPropagation();
                            recarregarDashboardEmpresa(empresa.id);
                          }}
                          disabled={Boolean(dashboardEmpresasCarregando[empresa.id])}
                        >
                          <RefreshIcon fontSize="small" />
                        </Button>
                      </Box>

                      <KeyboardArrowDownIcon className="empresa-resumo-seta" />
                    </Box>

                    <Collapse
                      in={Boolean(dashboardEmpresasAbertas[empresa.id])}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Grid container spacing={2} className="dashboard-bancos-collapse">
                        <Grid item xs={12} sm={6} md={4} className="itens-cards">
                          <Box className="dashboard-banco-card dashboard-banco-card-boletos">
                            <Box className="dashboard-banco-card-topo">
                              <Box className="dashboard-banco-identificacao">
                                <Box className="banco-icone">
                                  <DescriptionOutlinedIcon />
                                </Box>
                                <Box>
                                  <Box className="banco-nome">Boletos D+1</Box>
                                  <Box className="banco-agencia">
                                    <span className="titulos-quantidade">
                                      Quantidade: {empresa.boletosPendentes?.quantidade ?? 0} boletos
                                    </span>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>

                            <Box className="dashboard-banco-card-base">
                              <Box className="titulos-badge">
                                <DescriptionOutlinedIcon />
                              </Box>
                              <Box className="titulos-infos">
                                {empresa.boletosPendentes?.loading ? (
                                  <>
                                    <Skeleton variant="text" width={90} height={22} />
                                    <Skeleton variant="text" width={120} height={28} />
                                  </>
                                ) : (
                                  <strong className="titulos-valor">
                                    R$ {empresa.boletosPendentes?.valor ?? '0,00'}
                                  </strong>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        {dashboardEmpresasCarregando[empresa.id] &&
                          empresa.bancos.length === 0 &&
                          Array.from({ length: 2 }).map((_, index) => (
                            <Grid
                              key={`loading-${index}-${empresa.id}`}
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              className="itens-cards"
                            >
                              <Box className="dashboard-banco-card dashboard-banco-card-loading">
                                <Box className="dashboard-banco-card-topo">
                                  <Box className="dashboard-banco-identificacao">
                                    <Skeleton variant="circular" width={40} height={40} />
                                    <Box className="dashboard-banco-loading-textos">
                                      <Skeleton variant="text" width={120} height={24} />
                                      <Skeleton variant="text" width={100} height={20} />
                                    </Box>
                                  </Box>
                                </Box>

                                <Box className="dashboard-banco-card-base">
                                  <Skeleton variant="rounded" width={40} height={40} />
                                  <Box className="dashboard-banco-loading-textos">
                                    <Skeleton variant="text" width={90} height={20} />
                                    <Skeleton variant="text" width={130} height={28} />
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          ))}

                        {empresa.bancos.map((card, index) => (
                          <Grid
                            key={`${index}-${empresa.id}-${card.id}`}
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            className="itens-cards"
                          >
                            <Link
                              className="text-decoration-none"
                              onClick={() =>
                                setarParametrosFinanceiro(empresa.id, card.cod_conta_cobranca)
                              }
                              to={`/iframe/${encodeBase64UrlSafe(DepartamentosEnum.FINANCEIRO_CONTROLADORIA)}/${encodeBase64UrlSafe(SUBMENUS.REMESSAS_FINANCEIRO['CODSUBMENU'])}`}
                            >
                              <Box className={`dashboard-banco-card ${card.destaque ? 'destaque' : ''}`}>
                                <Box className="dashboard-banco-card-topo">
                                  <Box className="dashboard-banco-identificacao">
                                    <Box className="banco-icone background-neutro">
                                      {getBancoImagem(card.cod_banco) ? (
                                        <img
                                          src={getBancoImagem(card.cod_banco)}
                                          alt={card.banco}
                                          className="banco-icone-imagem"
                                        />
                                      ) : (
                                        <AccountBalanceIcon />
                                      )}
                                    </Box>
                                    <Box>
                                      <Box className="banco-nome">{card.banco}</Box>
                                      <Box className="banco-agencia">
                                        Agência: {card.agencia}
                                        {card.conta ? ` / Conta: ${card.conta}` : ''}
                                      </Box>
                                    </Box>
                                  </Box>
                                  <ArrowForwardIosIcon className="banco-seta" />
                                </Box>

                                <Box className="dashboard-banco-card-base">
                                  <Box className="titulos-badge">
                                    <DescriptionOutlinedIcon />
                                  </Box>
                                  <Box className="titulos-infos">
                                    <span className="titulos-quantidade">
                                      Carteira: {card.carteira || '-'}
                                    </span>

                                    <Box className="main-instrucoes-quadro">
                                      <Box className="instrucoes-quadro">
                                        <span className="instrucoes-quadro-titulo">Instruções:</span>
                                        {card.instrucoesPendentes?.loading ? (
                                          <Skeleton variant="text" width={36} height={24} />
                                        ) : (
                                          <strong className="instrucoes-quadro-quantidade">
                                            {card.instrucoesPendentes?.quantidade ?? 0}
                                          </strong>
                                        )}
                                      </Box>
                                      <Box className="instrucoes-quadro">
                                        <span className="instrucoes-quadro-titulo">Remessas:</span>
                                        {card.remessasPendentes?.loading ? (
                                          <Skeleton variant="text" width={36} height={24} />
                                        ) : (
                                          <strong className="instrucoes-quadro-quantidade">
                                            {card.remessasPendentes?.quantidade ?? 0}
                                          </strong>
                                        )}
                                      </Box>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Link>
                          </Grid>
                        ))}
                      </Grid>
                    </Collapse>
                  </Box>
                ))}
              </Box>
            </Grid>
          )}

          <Grid item xs={12} md={12} lg={12} xl={12}>
            <Box className="texto-indicacao">Sua carteira</Box>
            <Grid container className="container-boxes">
              {escopoAcesso?.plataforma_oneshell?.componente['saldo-operar'] && (
                <Grid item xs={12} md={4} lg={4} xl={4} className="mb-5 grid-item-home-right">
                  <Box className="box-item-home">
                    <Grid container className="grid-container">
                      <Grid item xs={3} sm={3} md={3} lg={2} xl={2}>
                        <Box className="icone-item roxo">
                          <IconesMenu name="money" />
                        </Box>
                      </Grid>
                      <Grid item xs={9} sm={9} md={9} lg={10} xl={10}>
                        <Box>
                          <span className="texto-item">Saldo para operar</span>
                        </Box>
                        <Box>
                          {isPendingSaldo && <Skeleton variant="text" width="100%" height={27} />}
                          {!isPendingSaldo && <b className="valor-item">R$ {valorSaldoOperar}</b>}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}

              {escopoAcesso?.plataforma_oneshell?.componente['saldo-vop'] && (
                <Grid item xs={12} md={4} lg={4} xl={4} className="mb-5 grid-item-home-center">
                  <Box className="box-item-home">
                    <Grid container className="grid-container">
                      <Grid item xs={3} sm={3} md={3} lg={2} xl={2}>
                        <Box className="icone-item verde">
                          <IconesMenu name="currency--dollar" />
                        </Box>
                      </Grid>
                      <Grid item xs={9} sm={9} md={9} lg={10} xl={10}>
                        <Box>
                          <span className="texto-item">VOP (mês atual)</span>
                        </Box>
                        <Box>
                          {isPendingValorOperado && <Skeleton variant="text" width="100%" height={27} />}
                          {!isPendingValorOperado && (
                            <b className="valor-item">R$ {valorSaldoOperado}</b>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}

              {escopoAcesso?.plataforma_oneshell?.componente['titulos-pendencias'] && (
                <Grid item xs={12} md={4} lg={4} xl={4} className="mb-5 grid-item-home-left">
                  <Box className="box-item-home">
                    <Grid container className="grid-container">
                      <Grid item xs={3} sm={3} md={3} lg={2} xl={2}>
                        <Box className="icone-item laranja">
                          <IconesMenu name="warning--diamond" />
                        </Box>
                      </Grid>
                      <Grid item xs={9} sm={9} md={9} lg={10} xl={10}>
                        <Box>
                          <span className="texto-item">Títulos com pendências </span>
                        </Box>
                        <Box>
                          {isPendingQtdPendencias && (
                            <Skeleton variant="text" width="100%" height={27} />
                          )}
                          {!isPendingQtdPendencias && <b className="valor-item">{qtdPendencias}</b>}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}
            </Grid>

            <Box className="main-card">
              <Box className="title-card">
                <strong>Personalize sua experiência:</strong>
              </Box>
              <Box className="cards-grupo lista-favoritos">
                <Grid container>
                  {!loadingFavoritos && (
                    <>
                      <BoxFavorito
                        favorito={SUBMENUS.CONTROLE_PAGAMENTOS}
                        disabled={isPendingSaldo}
                        permissao={permissaoTelaPagamentos}
                        controleTamanho={controleTamanho}
                      />
                      {listaDeFavoritos.map((favorito, index) => (
                        <BoxFavorito key={index} favorito={favorito} controleTamanho={controleTamanho} />
                      ))}
                    </>
                  )}

                  {loadingFavoritos &&
                    Array.from({ length: 4 }).map((_, index) => (
                      <Grid key={index} className="card-item-grid" item xs={12} md={controleTamanho}>
                        <Box className="card-item">
                          <Grid container spacing={2}>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={2}>
                              <Skeleton variant="circular" width={42} height={42} />
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={9} xl={10}>
                              <Skeleton variant="text" width="80%" height={24} />
                              <Skeleton variant="text" width="60%" height={20} />
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              </Box>
              <Button className="btn-personalizar-configuracoes button-cor-cliente display-none">
                Personalizar configurações
              </Button>
            </Box>
          </Grid>

          <Grid className="lista" item xs={12} md={12} lg={12} xl={12}>
            <Box className="card-dica">
              <StarSharpIcon className="star-icon" />
              <p className="texto-dica">
                Dica: salve suas páginas favoritas para acessá-las rapidamente! Comece explorando as
                principais funcionalidades para o seu dia a dia.
              </p>
            </Box>
          </Grid>
        </Grid>

        <ModalRecuperaCessao
          navegarTelaCapitalFlow={navegarTelaCapitalFlow}
          open={openModalRecuperaCessao}
          onClose={handleCloseModalRecuperaCessao}
          nomeEtapaCapitalFlow={nomeEtapaCapitalFlow}
          comecarNovajornada={comecarNovajornada}
        />

        <Snackbar
          open={openAlert}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="warning">
            Você não tem permissão para acessar esta tela.
          </Alert>
        </Snackbar>
      </Box>
    </Main>
  );
};

export default memo(Home);
